(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["articles-slider"] && !Shopify.designMode) return;
  try {
    
  const articlesSectionSlider = () => {
    new Swiper(".articles__slider", {
      freeMode: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: ".articles__slider .swiper-scrollbar",
        freeMode: true,
        draggable: true,
        hide: false
      },
      spaceBetween: 0,
      slidesPerView: 'auto',
      watchOverflow: true,
      centerInsufficientSlides: true,
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    articlesSectionSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-info-v2"] && !Shopify.designMode) return;
  try {
    
  const brandsInfoSlider = () => {
    new Swiper('.brands-info__swiper', {
      spaceBetween: 0,
      slidesPerView: "auto",
      loop: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      }
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    brandsInfoSlider();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-info"] && !Shopify.designMode) return;
  try {
    
  let brandSlider
  const brandsSwiper = () => {
    brandSlider = new Swiper('.brands-info_swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.6,
          centeredSlides: true,
          loop: true,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 20,
        }
      },
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
    });
  }
  function onResize() {
    const windowWidth = window.innerWidth;
    if (windowWidth >= 768) {
      brandSlider.disable();
    } else {
      brandSlider.enable();
      brandSlider.update();
      brandsSwiper();
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    brandsSwiper();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-slider"] && !Shopify.designMode) return;
  try {
    
  const cardsSlider = () => {
    new Swiper('.cards_slider_swiper', {
      slidesPerView: "auto",
      spaceBetween: 20,
      freeMode: true,
      centerInsufficientSlides: true,
      scrollbar: {
        el: '.cards_slider_swiper .swiper-scrollbar',
        freeMode: true,
        draggable: true,
        hide: false
      },
    })
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    cardsSlider();      
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-work"] && !Shopify.designMode) return;
  try {
    
    const handlePlayVideo = (event) => {
    const containers = document.querySelectorAll(".how_it_work__swiper .how_it_work__swiper__video");
    const currentContainer = event.target.closest(".how_it_work__swiper__video")
    const currentVideo = currentContainer.querySelector("video")
    const currentBtn = currentContainer.querySelector("button")

    containers.forEach(container => {
      const video = container.querySelector("video")
      const btn = container.querySelector("button")
      if (video !== currentVideo) {
        btn.classList.add("muted")
        video.muted = true
      }
    })

    currentBtn.classList.toggle("muted")
    currentVideo.muted = !currentVideo.muted;

  }

  const howItWorkSlider = () => {
    new Swiper('.how_it_work__swiper', {
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          loop: false,
        },
        400: {
          slidesPerView: 1.5,
          loop: false,
        },
        600: {
          slidesPerView: 2.5
        },
        900: {
          slidesPerView: 3
        },
        1344: {
          slidesPerView: 3
        },
        1500: {
          slidesPerView: 3
        },
        1980: {
          slidesPerView: 3
        }
      },
      loop: true,
      spaceBetween: 16,
      freeMode: false,
      watchOverflow: true,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: '.how_it_work__controls .swiper-button-next',
        prevEl: '.how_it_work__controls .swiper-button-prev',
      },
      pagination: {
        el: ".how_it_work__swiper .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  };

  document.addEventListener("DOMContentLoaded", function() {
    howItWorkSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  const multicolumnSlider = () => {
    new Swiper('.multicolumns_swiper', {
      slidesPerView: "auto",
      spaceBetween: 32,
      freeMode: true,
      centerInsufficientSlides: true,
      scrollbar: {
        el: '.multicolumns_swiper .swiper-scrollbar',
        freeMode: true,
        draggable: true,
        hide: false
      },
    })
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    multicolumnSlider();      
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-maelys"] && !Shopify.designMode) return;
  try {
    
  let clickResultsSwiper;
  let clickResultsSwiperDots;

  const bASwiper = () => {
    clickResultsSwiper = new Swiper('.before_after__swiper', {
      slidesPerView: 1,
      scrollbar: {
        el: '.before_after__swiper .swiper-scrollbar',
        freeMode: true,
        draggable: true,
        hide: false
      },
      on: {
        slideChange: s => {
          gtag('event', 'scroll_on_gallery', {
            position: (typeof s.realIndex === 'number' ? s.realIndex : s.activeIndex) + 1,
            section: "before_and_after"
          });
        }
      },
      spaceBetween: 15,
      centerInsufficientSlides: true,
      breakpoints: {
        768: {
         allowTouchMove: false,
         simulateTouch: false,
        },
      },
      mousewheel: {
        forceToAxis: true
      },
    })

    clickResultsSwiperDots = new Swiper('.before_after__swiper_dots', {
      slidesPerView: 4.5,
      freeMode: false,
      spaceBetween: 10,
      watchOverflow: 16,
      mousewheel: {
        forceToAxis: true
      },
    });
  }
  document.addEventListener('DOMContentLoaded', bASwiper)


  const clickDots = () => {
    let dots = document.querySelectorAll('.profile_pic');
    dots[0].classList.add('dotActive')

    for(let i=0; i < dots.length; i++){
      dots[i].addEventListener('click', () => {
        for(let i=0; i < dots.length; i++){
          dots[i].classList.remove('dotActive')
        }
        clickResultsSwiper.slideTo(i);
        dots[i].classList.add('dotActive')
      });
    }
  }

  document.addEventListener('DOMContentLoaded', clickDots)

  const SliderDots = () => {
    let clickResultCard = document.querySelector(".before_after__swiper")
    let startXClick;
    let distX;
    const profilePics = document.querySelectorAll(".profile_pic")
    let activeProfilePic = 0;

    profilePics.forEach((el, i) => {
        if (el.getAttribute("for") === event.target.value) {
          activeProfilePic = i;
        }
    })

    clickResultCard.addEventListener('touchstart', function(e) {
      let touch = e.touches[0];
      startXClick = touch.clientX;
      distX = 0;
      
    });

    clickResultCard.addEventListener('touchmove', function(e) {
      if (startXClick !== undefined) {
        let touch = e.touches[0];
        distX = touch.clientX - startXClick;
      }
    });

    clickResultCard.addEventListener('touchend', function() {
      if (distX > 0) {
        if (activeProfilePic > 0) {
          activeProfilePic--;
          profilePics[activeProfilePic].click()
          clickResultsSwiperDots.slideTo(activeProfilePic)
        }
      } else if (distX < 0) {
        if (activeProfilePic < (profilePics.length - 1)) {
          activeProfilePic++;
          profilePics[activeProfilePic].click()
          clickResultsSwiperDots.slideTo(activeProfilePic)
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', SliderDots)
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-table"] && !Shopify.designMode) return;
  try {
    
  const tableSlider = () => {
    new Swiper('.slider-table__swiper', {
      slidesPerView: "auto",
      spaceBetween: 10,
      freeMode: true,
      centerInsufficientSlides: true,
      scrollbar: {
        el: '.slider-table__swiper .swiper-scrollbar',
        freeMode: true,
        draggable: true,
        hide: false
      },
    })
  }
  
  if (window.innerWidth < 769) {
    document.addEventListener("DOMContentLoaded", () => {
      tableSlider();      
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-banner"] && !Shopify.designMode) return;
  try {
    
  const setSubscription = () => {
    const link = "/products/redu-sculpt%E2%84%A2-subscription"
    const container = document.querySelector(".product_section")
    const elementToGo = container.querySelector('.bundles_container')
    const label = container.querySelector("label[for='subscription']")
    const topSpace = 55
    
    if (label) {
      label.click()

      if (elementToGo) {
        const elementToGoPosition = elementToGo.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementToGoPosition - topSpace,
          behavior: 'smooth'
        });
      }
    } else {
      window.location.href = link
    }
  }

  window.setSubscription = setSubscription;

  document.addEventListener("DOMContentLoaded", function() {
    new Swiper(".sub-banner__items", {
      freeMode: false,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: ".sub-banner__items .swiper-scrollbar",
        freeMode: true,
        draggable: true,
        hide: false
      },
      spaceBetween: 6,
      slidesPerView: 2.2,
      watchOverflow: true,
      centerInsufficientSlides: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["targets"] && !Shopify.designMode) return;
  try {
    
  const targetsSlider = () => {
    new Swiper('.targets__swiper', {
      spaceBetween: 24,
      slidesPerView: "auto",
      freeMode: true,
      watchOverflow: true,
      centerInsufficientSlides: true,
      pagination: {
        el: ".targets__dots",
        type: "bullets",
        clickable: true,
      },
    });
  };

  document.addEventListener("DOMContentLoaded", function() {
    targetsSlider();
  });

  } catch(e) { console.error(e); }
})();
})();
